import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import * as storage from "utils/local-storage";
import {
  SPEED_ACCOUNT_ID,
  SPEED_LIGHTNING_ADDRESS,
  SPEED_LANG,
  SPEED_BAL_BTC,
  SPEED_BAL_USDT,
} from "utils/constants";

/**
 * Capture Speed Wallet Mini App URL params into sessionStorage whenever they
 * show up in the URL — on any route.
 *
 * Why this exists (instead of relying on InitializeIntegrationApp):
 *   - InitializeIntegrationApp only runs on the `/integration-app/<slug>` path.
 *   - Speed Wallet may load our Mini App at a different URL (e.g. `/`,
 *     `/g/<slug>`), in which case the handshake never fires and downstream
 *     reads of `acct` / `p_add` see an empty session — surfacing as the
 *     "Speed Wallet session expired" toast on Deposit.
 *
 * Speed sends `acct` only once, at iframe mount, so this effect is a cheap
 * idempotent write: if `acct` is in the current URL, persist it; otherwise
 * do nothing. Components read back via `getSpeedSession()`.
 */
export const useSpeedSessionHandshake = () => {
  const { search } = useLocation();

  useEffect(() => {
    const qp = new URLSearchParams(search);
    const acct = qp.get("acct");
    if (!acct) {
      return;
    }

    // eslint-disable-next-line no-console
    console.log("[speed] capturing handshake params from URL", { acct, search });

    storage.session.setItem(SPEED_ACCOUNT_ID, acct);

    const pAdd = qp.get("p_add");
    if (pAdd !== null) {
      storage.session.setItem(SPEED_LIGHTNING_ADDRESS, pAdd);
    }
    const lang = qp.get("lang");
    if (lang !== null) {
      storage.session.setItem(SPEED_LANG, lang);
    }
    const balBtc = qp.get("bal_btc");
    if (balBtc !== null) {
      storage.session.setItem(SPEED_BAL_BTC, balBtc);
    }
    const balUsdt = qp.get("bal_usdt");
    if (balUsdt !== null) {
      storage.session.setItem(SPEED_BAL_USDT, balUsdt);
    }
  }, [search]);
};
